export default "__VITE_ASSET__d_2Lv24A__"